import React from 'react';
import useTurnstileCaptcha from '../hooks/useTurnstileCaptcha';

/*
 * withTurnstile - used as a HOC for using turnstile captcha hook inside
 *                 class based components.
 */
const withTurnstile = Component => props => {

    const { turnstileCaptcha, turnstileToken, turnstileError,
        resetTurnstileToken, isTurnstileUp, isTurnstileLoading,
        textCaptcha, onRefreshCaptcha, isCaptchaInvalid,
        captcha, captchaImage } = useTurnstileCaptcha(props.pageNumber);

    return <Component turnstileCaptcha={turnstileCaptcha}
        turnstileToken={turnstileToken}
        turnstileError={turnstileError}
        resetTurnstileToken={resetTurnstileToken}
        isTurnstileUp={isTurnstileUp}
        isTurnstileLoading={isTurnstileLoading}
        textCaptcha={textCaptcha}
        onRefreshCaptcha={onRefreshCaptcha}
        isCaptchaInvalid={isCaptchaInvalid}
        captcha={captcha}
        captchaImage={captchaImage}
        {...props} />;
};

export default withTurnstile;